import { render } from "./BannedDomains.vue?vue&type=template&id=8c9d385e&scoped=true"
import script from "./BannedDomains.vue?vue&type=script&lang=js"
export * from "./BannedDomains.vue?vue&type=script&lang=js"

import "./BannedDomains.vue?vue&type=style&index=0&id=8c9d385e&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c9d385e"]])

export default __exports__